import { DISPONIBILIDADE_INICIO } from "./../../../constants/disponibilidade_inicio";
import { useState, useEffect } from "react";
import {
  ICandidaturaFormProps,
  ICandidaturaResumidaDTO,
} from "../../../types/candidatura";
import { DISPONIBILIDADE_VIAGEM } from "../../../constants/disponibilidade_viagem";
import { VAGA } from "../../../constants/vaga";
import { toOptions } from "../../../utils/toOptions";
import { GENERO } from "../../../constants/genero";
import { ViaCep } from "../../../services/ViaCep";
import { toast } from "react-toastify";
import { useContextSite } from "../../../context/Context";
import { ESTADOS } from "../../../constants/estados";
import { Ibge } from "../../../services/Ibge";
import { ISelectOptions } from "../../../types/inputs";
import { ESCOLARIDADE } from "../../../constants/escolaridade";
import { Candidatura } from "../../../services/Candidatura";
import { useNavigate } from "react-router-dom";
import { IArquivoDTO } from "../../../types/arquivo";

const DisponibilidadeInicioOptions = toOptions(DISPONIBILIDADE_INICIO);
const DisponibilidadeViagemOptions = toOptions(DISPONIBILIDADE_VIAGEM);
const VagaOptions = toOptions(VAGA);
const GeneroOptions = toOptions(GENERO);
const EscolaridadeOptions = toOptions(ESCOLARIDADE);
const EstadosOptions = ESTADOS.map((sigla) => ({
  label: sigla,
  value: sigla,
}));
export const useWorkWithUs = () => {
  const [form, setForm] = useState<ICandidaturaFormProps>(
    {} as ICandidaturaFormProps
  );
  const [data, setData] = useState<ICandidaturaResumidaDTO>(
    {} as ICandidaturaResumidaDTO
  );
  const navigate = useNavigate();
  const { setIsLoad } = useContextSite();
  const [arquivo, setArquivo] = useState<IArquivoDTO>({} as IArquivoDTO);
  const [cidadesOptions, setCidadesOptions] = useState<ISelectOptions[]>([]);

  const updateForm = (values: Partial<ICandidaturaFormProps>) => {
    setForm((prev) => ({
      ...prev,
      ...values,
      endereco: {
        ...prev.endereco,
        ...(values.endereco ?? {}),
      },
    }));
  };

  useEffect(() => {
    setIsLoad(true);

    Candidatura.post()
      .then(({ data }) => setData(data))
      .catch(
        ({
          response: {
            data: { mensagem },
          },
        }) => toast.error(mensagem)
      )
      .finally(() => setIsLoad(false));
  }, []);

  useEffect(() => {
    if (form?.endereco?.cep?.length === 9) {
      const cep = form?.endereco?.cep.replace(/\D/g, "");
      setIsLoad(true);
      ViaCep.get(cep)
        .then(({ data }) => {
          setForm((prev) => ({
            ...prev,
            endereco: {
              ...prev.endereco,
              logradouro: data.logradouro || "",
              bairro: data.bairro || "",
              cidade: data.localidade || "",
              uf: data.uf || "",
            },
          }));
        })
        .catch((err) => toast.error("Erro ao buscar CEP:", err))
        .finally(() => setIsLoad(false));
    }
  }, [form?.endereco?.cep]);

  useEffect(() => {
    if (form?.endereco?.uf) {
      Ibge.CidadesPorEstado({ sigla: form?.endereco?.uf })
        .then(({ data }) => {
          const options = data.map((item) => ({
            value: item.nome,
            label: item.nome,
            element: item,
          }));
          setCidadesOptions(options);
        })
        .catch((erro) => toast.error("Erro ao requisitar as cidades"));
    }
  }, [form?.endereco?.uf]);

  function handleFileChange(file: File | null) {
    if (!file) return;
    setIsLoad(true);

    Candidatura.anexar_arquivo({ file, uuid: data.uuid })
      .then(({ data }) => {
        setArquivo(data.arquivo);
      })
      .catch(
        ({
          response: {
            data: { mensagem },
          },
        }) => toast.error(mensagem)
      )
      .finally(() => setIsLoad(false));
  }

  function handleFileDelete(uuid) {
    setIsLoad(true);
    Candidatura.deletar_arquivo({ uuid: data.uuid, uuidArquivo: uuid })
      .then(() => {
        setArquivo({} as IArquivoDTO);
        toast.success("Arquivo deletado com sucesso!");
      })
      .catch(
        ({
          response: {
            data: { mensagem },
          },
        }) => toast.error(mensagem)
      )
      .finally(() => setIsLoad(false));
  }
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    setIsLoad(true);

    const PAYLOAD: ICandidaturaFormProps = {
      ...form,
      uuid: data.uuid,
    };

    Candidatura.put(PAYLOAD)
      .then(() => {
        toast.success("Candidatura enviada com sucesso!");
        setTimeout(() => {
          navigate("/");
        }, 1500);
      })
      .catch(
        ({
          response: {
            data: { mensagem },
          },
        }) => toast.error(mensagem)
      )
      .finally(() => setIsLoad(false));
  };

  return {
    form,
    updateForm,
    handleSubmit,
    DisponibilidadeInicioOptions,
    DisponibilidadeViagemOptions,
    VagaOptions,
    GeneroOptions,
    EstadosOptions,
    arquivo,
    setArquivo,
    cidadesOptions,
    EscolaridadeOptions,
    handleFileChange,
    handleFileDelete,
  };
};
